<div [class]="{ 'px-sm-3': !suppressUI, 'px-md-4': !suppressUI }" class="ms-sm-auto font-size-sm">
  <form [formGroup]="includeCDSForm">
    <span class="form-check">
      <input id="IncludeCDS" type="checkbox" class="form-check-input" formControlName="IncludeCDS"/>
      <label for="IncludeCDS" class="form-check-label">{{labelText}}
        <ness-info-tooltip [tooltipStyleClass]="tooltipStyleClass">
          <ng-content></ng-content>
        </ness-info-tooltip>
      </label>
    </span>
  </form>
</div>
